import { DeduplicationTask } from '@idea2app/ai-work-order-service';
import { Filter } from 'mobx-restful';

import { TableModel } from './Base';
import userStore from './User';

export class DeduplicationTaskModel extends TableModel<
    DeduplicationTask,
    Filter<DeduplicationTask>
> {
    baseURI = '/task/deduplication';
    client = userStore.client;
}

export default new DeduplicationTaskModel();
